import axios from "../../../utils/axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// @mui
import { alpha } from "@mui/material/styles";
import { Box, Divider, Typography, MenuItem } from "@mui/material";
// routes
import { PATH_AUTH } from "../../../routes/paths";
// auth
import { useAuthContext } from "../../../auth/useAuthContext";
// components
import { CustomAvatar } from "../../../components/custom-avatar";
import { useSnackbar } from "../../../components/snackbar";
import MenuPopover from "../../../components/menu-popover";
import { IconButtonAnimate } from "../../../components/animate";
import { getLocalIPs } from "src/utils/getLocalIPs";
import { gatherBrowserInfo } from "src/utils/gatherBrowserInfo"
import VenueSelectionModal from "../../../sections/auth/VenueSelectionModal";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();

  const { user, logout, canSwitchVenue, openVenueSwitcher } = useAuthContext();

  const { enqueueSnackbar } = useSnackbar();

  const [openPopover, setOpenPopover] = useState(null);
  
  const [localIPs, setLocalIPs] = useState([]);
  const [browserInfo, setBrowserInfo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const browserInformation = await gatherBrowserInfo();
        setBrowserInfo(browserInformation);

        const ip = await getLocalIPs();
        setLocalIPs(ip);
      } catch (error) {
        console.error('Error fetching info:', error);
      }
    };

    fetchData();
  }, []);

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleSwitchBranch = () => {
    handleClosePopover();
    openVenueSwitcher();
  };

  const handleLogout = async () => {
    if (user?.isImpersonating) {
      const adminAppUrl = process.env.REACT_APP_ADMIN_APP_URL;
      try {
        await axios.post(`${backendUrl}/authv/impersonation/end`);
      } catch (error) {
        // An expired/revoked session must not strand local credentials.
      } finally {
        logout();
        enqueueSnackbar("Impersonation session ended", { variant: "success" });
        handleClosePopover();
        if (adminAppUrl) {
          window.location.assign(
            new URL(user?.adminReturnPath || "/dashboard/franchise/list", adminAppUrl).toString()
          );
        } else {
          navigate(PATH_AUTH.login, { replace: true });
        }
      }
      return;
    }

    try {
      const refreshToken = sessionStorage.getItem("refreshToken");
      const resp = await axios.post(`${backendUrl}/authv/logout`,{
        refreshToken: refreshToken,
        user: user,
        ipAddress: localIPs[0],
        browserInfo
      });
      if(resp.status === 204){
        logout();
        navigate(PATH_AUTH.login, { replace: true });
        handleClosePopover();
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Unable to logout!", { variant: "error" });
    }
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          ...(openPopover && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}>
        <CustomAvatar
          src={user?.photoURL}
          alt={user?.displayName}
          name={user?.displayName}
        />
      </IconButtonAnimate>

      <MenuPopover
        open={openPopover}
        onClose={handleClosePopover}
        sx={{ width: 200, p: 0 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.displayName}
          </Typography>

          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        {/* <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem
              key={option.label}
              onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: "dashed" }} /> */}

        {canSwitchVenue && !user?.isImpersonating && (
          <MenuItem onClick={handleSwitchBranch} sx={{ mx: 1, mt: 1 }}>
            Switch Branch
          </MenuItem>
        )}

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          {user?.isImpersonating ? "Back to Admin" : "Logout"}
        </MenuItem>
      </MenuPopover>

      <VenueSelectionModal />
    </>
  );
}
